/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { ButtonPrimary } from "./NewButtons";
import { ProductListItem } from "../module/products/models/product";
import { SelectProductsDrawer } from "./SelectProductsDrawer";

type Props = {
  onSave: (addedProducts: ProductListItem[]) => void | Promise<void>;
  filters: { classification: string };
  productIdsToLeaveOut?: string[];
  buttonText: string;
  isLoadingSave?: boolean;
  modalHeader: string;
  includeClassificationFilter?: boolean;
  filterProductsFunction?: (products: ProductListItem[]) => ProductListItem[];
};

export const SelectProductsSelector = ({
  onSave,
  filters,
  productIdsToLeaveOut,
  buttonText,
  modalHeader,
  isLoadingSave,
  includeClassificationFilter = false,
  filterProductsFunction,
}: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonPrimary
        type="button"
        onClick={() => setModalOpen(true)}
        icon={<FontAwesomeIcon icon={solid("plus")} />}
      >
        {buttonText}
      </ButtonPrimary>
      <SelectProductsDrawer
        isOpen={modalOpen}
        filters={filters}
        productIdsToLeaveOut={productIdsToLeaveOut}
        filterProductsFunction={filterProductsFunction}
        buttonText={buttonText}
        modalHeader={modalHeader}
        isLoadingSave={isLoadingSave}
        includeClassificationFilter={includeClassificationFilter}
        onClose={() => setModalOpen(false)}
        onSave={async (addedProducts) => {
          await onSave(addedProducts || []);
        }}
      />
    </div>
  );
};
